import { PageConfig } from '@app/Modules/type';
import FilterDateMonth from './Custom/FilterDateMonth';
import CustomCommandeClub from './Custom/CustomCommandeClub';
import FilterCollaborateur from './Custom/FilterCollaborateur';
import FilterUserLogin from './Custom/FilterUserLogin';
import FilterStatutEnDate from './Custom/FilterStatutEnDate';
import ValidateReconductionsNonRenouvelees from './Custom/ValidateReconductionsNonRenouvelees';

type props = {
    pageConfig: PageConfig;
    onSuccess: () => void;
    selected?: string[];
};
const CustomAction = ({ pageConfig, onSuccess, selected = [] }: props) => {
    return (
        <>
            {pageConfig.config.apiUrl === '/commandes' && (
                <CustomCommandeClub onSuccess={onSuccess} />
            )}
            {pageConfig.config.apiUrl === '/view-parrainages/currentMonth' && (
                <>
                    <FilterDateMonth filterBy="dateAccord" />
                    <FilterCollaborateur filterBy="collaborateur/id" />
                </>
            )}
            {pageConfig.config.indentifier === 'listeNoireUserAdminSchema' && (
                <>
                    <FilterDateMonth
                        filterBy="dateListeNoire"
                        defautCurrentDate={false}
                    />
                    <FilterUserLogin filterBy="collaborateur" />
                </>
            )}
            {pageConfig.config.indentifier === 'ballonDueToClubSchema' && (
                <>
                    <FilterStatutEnDate filterBy="StatutDate" />
                </>
            )}
            {pageConfig.config.indentifier === 'materialDueToClubSchema' && (
                <>
                    <FilterStatutEnDate filterBy="StatutDate" />
                </>
            )}
            {pageConfig.config.indentifier === 'parrainagesReconductionsSchema' && (
                <ValidateReconductionsNonRenouvelees
                    onSuccess={onSuccess}
                    selected={selected}
                />
            )}
        </>
    );
};

export default CustomAction;
